<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>微信管理</el-breadcrumb-item> 
      <el-breadcrumb-item>院线观影</el-breadcrumb-item> 
    </el-breadcrumb>
    <div class="Tab_Css">
      <div :class="index=='1'?'Tab_Active':''" @click="tabs(1)">演出列表</div>
      <div :class="index=='2'?'Tab_Active':''" @click="tabs(2)">区域座位管理</div>
      <div :class="index=='3'?'Tab_Active':''" @click="tabs(3)">分类管理</div>
      <div :class="index=='4'?'Tab_Active':''" @click="tabs(4)">订单管理</div>
    </div>
    <div class="box" v-if="index==1">
      <div class="box_top">
        <div class="condition">
          <el-input v-model="data.movie_name" placeholder="演出名称"></el-input>
          <el-select v-model="data.status" clearable placeholder="全部状态">
            <el-option
              v-for="item in optstatus"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="select_btns" @click="ListBtns">查询</div>
        </div>
          <div class="btns">
              <div @click="addlistPush('')">创建</div>
              <div @click="sortBlur1">排序</div>
              <div @click="listDetePl()">删除</div>
          </div>
      </div>
      <div class="table_box">
          <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            style="width: 100%"
            ref="multipleTable"
            @selection-change="handleSelectList"
          >
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column  label="排序" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.sort"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="演出名称" prop="movie_name"></el-table-column>
            <el-table-column  label="状态">
              <template slot-scope="scope">
                {{scope.row.status==1?'上架':'下架'}}
              </template>
            </el-table-column>
            <el-table-column prop="type_name" label="分类">
            </el-table-column>
            <el-table-column prop="num" label="已售">
            </el-table-column>
            <el-table-column  label="操作" width="350"    fixed="right">
              <template slot-scope="scope">
                  <div class="operation">
                    <div class="add_bianji" @click="dateClick(scope.row)">演出日期</div>
                    <div class="add_bianji" @click="priceClick(scope.row)">价格设置</div>
                    <div class="add_bianji" @click="changciset(scope.row)">场次设置</div>
                    <div class="add_bianji" @click="addlistPush(scope.row)">编辑</div>
                    <div class="detele" @click="listDete(scope.row)">删除</div>
                  </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <span class="totla">排序规则遵循降序规则，数据按照从大到小的顺序排列，数据越大内容越往前，新填加的内容系统默认排序为0</span>
            <span class="demonstration">共{{total}}条记录，</span>
            <span class="demonstration">当前显示第{{data.page}}页</span>
            <el-pagination background layout="prev, pager, next" :page-size="data.page_size" :total="total" @current-change="ListChangeOne"></el-pagination>
          </div>
      </div>
    </div>
    <div class="box" v-if="index==2">
      <div class="box_top box_top_end">
          <div class="btns">
              <div @click="addseat('')">创建</div>
              <div @click="deleAreaList">删除</div>
          </div>
      </div>
      <div class="table_box">
          <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            style="width: 100%"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column prop="area_name" label="区域名称"></el-table-column>
            <el-table-column prop="seat_num" label="座位数"></el-table-column>
            <el-table-column  label="区域分类">
                <template slot-scope="scope">
                  {{scope.row.area_type=='1'?'选座':scope.row.area_type=='2'?'包房':'无座'}}
                </template>
            </el-table-column>
            <el-table-column  label="状态">
              <template slot-scope="scope">
                <span @click="updateArea(scope.row)" :class="scope.row.area_status=='1'?'table_span_text':'close_span'">{{scope.row.area_status=='1'?'上架':'下架'}}</span>    
              </template>
            </el-table-column>
            <el-table-column  label="操作" width="100"   fixed="right">
              <template slot-scope="scope">
                  <div class="operation">
                    <div class="add_bianji" @click="addseat(scope.row)">编辑</div>
                    <div class="detele" @click="deteleArea(scope.row)">删除</div>
                  </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <span class="demonstration">共{{total}}条记录，</span>
            <span class="demonstration">当前显示第{{dataArea.page}}页</span>
            <el-pagination background layout="prev, pager, next" :page-size="dataArea.page_size" :total="total" @current-change="AreaChange"></el-pagination>
          </div>
        </div>
    </div>
    <div class="box" v-if="index==3">
        <div class="box_top" style="justify-content: flex-end;"> 
          <!-- <el-switch
            v-model="value1"
            >
          </el-switch> -->
          <div class="btns">
              <div @click="addTypes('')">创建</div>
              <div @click="deteTypesList">删除</div>
          </div>
        </div>
        <div class="table_box">
          <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            style="width: 100%"
            ref="multipleTable"
            @selection-change="handleSelecType"
          >
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column label="排序" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.sort" @blur="sortBlur(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="type_name" label="分类名称"></el-table-column>
            <el-table-column  label="操作" width="100"   fixed="right">
              <template slot-scope="scope">
                  <div class="operation">
                    <div class="add_bianji" @click="addTypes(scope.row)">编辑</div>
                    <div class="detele" @click="deteleTypes(scope.row)">删除</div>
                  </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <span class="totla">排序规则遵循降序规则，数据按照从大到小的顺序排列，数据越大内容越往前，新填加的内容系统默认排序为0</span>
            <span class="demonstration">共{{total}}条记录，</span>
            <span class="demonstration">当前显示第{{typeData.page}}页</span>
            <el-pagination background layout="prev, pager, next" :page-size="typeData.page_size" :total="total" @current-change="ListChange"></el-pagination>
          </div>
        </div>
    </div>
    <div class="box" v-if="index==4">
      <div class="box_top">
        <div class="condition">
          <el-input v-model="dataorder.mobile" placeholder="手机号"></el-input>
          <el-input v-model="dataorder.order_number" placeholder="订单号"></el-input>
          <span style="margin-left:2rem;"> 日期：</span>
          <el-date-picker
          v-model="ordertime"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
          <el-select v-model="dataorder.order_status" clearable placeholder="支付状态 ">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="select_btns" @click="orderBtns">查询</div>
          <div class="select_btns" @click="exportClick">导出报表</div>
        </div>
        <div class="btns">
        
        </div>
      </div>
      <div class="table_box">
          <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            style="width: 100%"
          >
            <el-table-column label="下单时间" prop="Name"></el-table-column>
            <el-table-column prop="Name" label="销售渠道">
              <template slot-scope="scope">
                {{scope.row.way=='1'?'微商城':'小程序'}}
              </template>
            </el-table-column>
            <el-table-column prop="order_number" label="订单号"></el-table-column>
            <el-table-column prop="mobile" label="手机号"></el-table-column>
            <el-table-column  label="订单内容">
              <template slot-scope="scope" >
                  <div class="orderContent" v-for="item in scope.row.order_derail" :key="item.id">
                    <span >{{item.movie_name}}</span>
                    <span >场次时间：{{item.movie_showtimes_time}}</span>
                    <span>场馆：{{item.area_name}}  座位：{{item.seat_name}}</span>
                  </div>
              </template>
            </el-table-column>
            <el-table-column prop="order_amount" label="订单金额">
            </el-table-column>
            <el-table-column  label="订单状态">
              <template slot-scope="scope">
                {{scope.row.order_status=='1'?'待使用':scope.row.order_status=='2'?'已使用':'已退款'}}
              </template>
            </el-table-column>
            <el-table-column  label="操作" width="270"   fixed="right">
              <template slot-scope="scope">
                  <div class="operation">
                    <div class="add_bianji" @click="seeInfoFn(scope.row)">查看详情</div>
                  </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <span class="demonstration">共{{total}}条记录，</span>
            <span class="demonstration">当前显示第{{dataorder.page}}页</span>
            <el-pagination background layout="prev, pager, next" :page-size="dataorder.page_size" :total="total" @current-change="orderChange"></el-pagination>
          </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"
      title="添加分类"
      :visible.sync="Visible"
      :before-close="Close"
      width="20.6%"
      center
      top="30vh"
    >
      <el-divider></el-divider>
      <div class="RechargeContent">
        <el-form ref="formRe" :model="formRe" label-width="90px">
          <div class="RechargeItem">
            <el-form-item label="分类名称：">
              <el-input v-model="formRe.type_name" maxlength="15" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <div class="itemBtnS" >
              <div @click="Close">取消</div>
              <div @click="addTypeSucc">完成</div>
          </div>
        </el-form>
      </div>
      <!-- 分页结束 -->
    </el-dialog>
    <!-- <div class="order_boxs"> -->
      <orderDialog v-if="seeinfovisible" ref="seeinfoDialog"  @orderClose="dialogClose"></orderDialog>
    <!-- </div> -->
  </div>
</template>
<script>
import orderDialog from "./dialog/cinemaorder.vue";
import { getMovieTypeList , addMovieType , getMovieTypeInfo , updateMovieType , deleteMovieType , sortMovieType ,
  getMovieOrderList , getMovieAreaList , updateStatusMovieArea , deleteMovieArea ,
  getMovieList , movieSort , deleteMovie , exportMovieOrderList } from '@/request/scenic.js'
import { Message , MessageBox } from 'element-ui'
export default {
  components: {
    orderDialog,
  },
  data(){
    return{
      seeinfovisible:false,
      index:1,
      value1:false,
      tableData:[],
      Visible:false,
      formRe:{
        token:window.sessionStorage.getItem('Token'),
        type_name:''
      },
      options: [{
        value: '1',
        label: '待使用'
      }, {
        value: '2',
        label: '已使用'
      }, {
        value: '3',
        label: '已退款'
      }],
      value: '',
      typeData:{
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:8
      },
      total:0,
      multipleSelection:[],
      dataorder:{
        token:window.sessionStorage.getItem('Token'),
        order_number:'',
        mobile:'',
        order_status:'',
        page:1,
        page_size:8
      },
      input:'',
      ordertime:[],
      dataArea:{
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:8
      },
      data:{
        token:window.sessionStorage.getItem('Token'),
        status:'',
        movie_name:'',
        page:1,
        page_size:8
      },
      optstatus:[
        {
          value:'1',
          label:'上架'
        },
        {
          value:'2',
          label:'下架'
        }
      ]
    }
  },
  created(){
    if(this.$route.query.sort){
      this.tabs(this.$route.query.sort)
    }else{
      this.getList()
    }
  },
  methods:{
    exportClick(){
      // dataorder
      exportMovieOrderList(this.dataorder).then(res=>{
        if(res.data.status=='ok'){
          window.location.href = res.data.result
        }
      })
    },
    handleSelectList(val){
      this.multipleSelection = []
      this.multipleSelection = val
    },
    listDetePl(){
      if(this.multipleSelection.length==0){
        this.$message.error('请选择演出')
        return false
      }
      MessageBox(`此操作将批量删除演出, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let id = ''
        this.multipleSelection.map(item=>{ 
          id += item.id + ','
        })
        id = id.slice(0,-1)
        let data = {
          ids:id,
          token:window.sessionStorage.getItem('Token'),
        }
        deleteMovie(data).then(res=>{
          if(res.data.status=='ok'){
            this.$message.success('批量删除演出成功')
            this.data.page = 1
            this.getList()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
                
      });
    },
    listDete(row){
      MessageBox(`此操作将删除该演出, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let data = {
            token:window.sessionStorage.getItem('Token'),
            ids:row.id
          }
          deleteMovie(data).then(res=>{
            if(res.data.status=='ok'){
              this.$message.success('删除演出成功')
              this.data.page = 1
              this.getList()
            }else{
              this.$message.error(res.data.msg)
            }
          })
      }).catch(() => {
                
      });
    },
    priceClick(row){
      this.$router.push({
        name:'addlist',
        query:{
          id:row.id,
          sort:'2'
        }
      })
    },
    changciset(row){
      this.$router.push({
        name:'addlist',
        query:{
          id:row.id,
          sort:'3'
        }
      })
    },
    dateClick(row){
      this.$router.push({
        name:'showdate',
        query:{
          id:row.id
        }
      })
    },
    handleSelect(val){
      this.multipleSelection = []
      this.multipleSelection = val
    },
    handleSelectionChange(val){
      this.multipleSelection = []
      this.multipleSelection = val
    },
    sortBlur(row){
      if(row.sort<0){
        this.$message.error('请输入大于0的整数')
        return false
      }else{
        let num = /^[0-9]*$/.test(row.sort)
        if(num){
        }else{
          this.$message.error('请输入整数')
          return false
        }
      }
      let data = {
        id:row.id,
        token:window.sessionStorage.getItem('Token'),
        sort:row.sort
      }
      sortMovieType(data).then(res=>{
        if(res.data.status=='ok'){
          this.$message.success('排序成功')
          this.getListType()
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    handleSelecType(val){
      this.multipleSelection = val;
    },
    deteTypesList(){
      if(this.multipleSelection.length==0){
        this.$message.error('请选择分类')
        return false
      }
      MessageBox(`此操作将批量删除分类, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let id = ''
        this.multipleSelection.map(item=>{ 
          id += item.id + ','
        })
        id = id.slice(0,-1)
        let data = {
          ids:id,
          token:window.sessionStorage.getItem('Token'),
        }
        deleteMovieType(data).then(res=>{
          if(res.data.status=='ok'){
            this.$message.success('批量删除分类成功')
            this.typeData.page = 1
            this.getListType()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
                
      });
    },
    deteleTypes(row){
      MessageBox(`此操作将删除该分类, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let data = {
            token:window.sessionStorage.getItem('Token'),
            ids:row.id
          }
          deleteMovieType(data).then(res=>{
            if(res.data.status=='ok'){
              this.$message.success('删除成功')
              this.typeData.page = 1
              this.getListType()
            }else{
              this.$message.error(res.data.msg)
            }
          })
      }).catch(() => {
                
      });
    },
    addTypeSucc(){
      if(this.formRe.type_name==''){
        Message.error('请输入分类名称')
        return false
      }
      if(this.formRe.id){
        updateMovieType(this.formRe).then(res=>{
          if(res.data.status=='ok'){
            Message.success('修改分类成功')
            this.Visible = false
            this.formRe.type_name = ''
            this.typeData.page = 1
            this.getListType()
          }else{
            Message.error(res.data.msg)
          }
        })
      }else{
        addMovieType(this.formRe).then(res=>{
          if(res.data.status=='ok'){
            Message.success('添加分类成功')
            this.Visible = false
            this.formRe.type_name = ''
            this.typeData.page = 1
            this.getListType()
          }else{
            Message.error(res.data.msg)
          }
        })
      }
    },
    tabs(i){
      if(this.index==i){
        return false
      }
      this.index = i 
      if(this.index==3){
        this.tableData = []
        this.getListType()
      }else if(this.index==4){
        this.tableData = []
        this.orderList()
      }else if(this.index==2){
        console.log(123456)
        this.tableData = []
        this.getareaList()
      }else if(this.index==1){
        this.tableData = []
        this.getList()
      }
    },
    sortBlur1(row){
      if(this.multipleSelection.length==0){
        this.$message.error('请选择演出数据')
        return false
      }
      let option = []
      this.multipleSelection.map(item=>{
        option.push({
          sort:item.sort,
          id:item.id
        })
      })
      let data = {
        token:window.sessionStorage.getItem('Token'),
        sort:option
      }
      movieSort(data).then(res=>{
        if(res.data.status=='ok'){
          this.$message.success('排序成功')
          this.getList()
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    ListChangeOne(e){
      this.data.page = e
      this.getList()
    },
    ListBtns(){
      this.data.page = 1
      this.getList()
    },
    getList(){
      getMovieList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.total = res.data.result.total
          this.tableData = res.data.result.data
        }
      })
    },
    deteleArea(row){
      MessageBox(`此操作将删除该区域, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let data = {
            token:window.sessionStorage.getItem('Token'),
            ids:row.id
          }
          deleteMovieArea(data).then(res=>{
            if(res.data.status=='ok'){
              this.$message.success('删除成功')
              this.dataArea.page = 1
              this.getareaList()
            }else{
              this.$message.error(res.data.msg)
            }
          })
      }).catch(() => {
                
      });
    },
    deleAreaList(){
      if(this.multipleSelection.length==0){
        this.$message.error('请选择区域')
        return false
      }
      MessageBox(`此操作将批量删除区域, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let id = ''
        this.multipleSelection.map(item=>{ 
          id += item.id + ','
        })
        id = id.slice(0,-1)
        let data = {
          ids:id,
          token:window.sessionStorage.getItem('Token'),
        }
        deleteMovieArea(data).then(res=>{
          if(res.data.status=='ok'){
            this.$message.success('批量删除区域成功')
            this.dataArea.page = 1
            this.getareaList()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
                
      });
    },
    AreaChange(e){
      this.dataArea.page = e
      this.getareaList()
    },
    // 修改区域状态
    updateArea(row){
      console.log(row.area_status)
      let stat = row.area_status=='1'?'下架':'上架'
      MessageBox(`此操作将${stat}该区域, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          token:window.sessionStorage.getItem('Token'),
          id:row.id,
          area_status:row.area_status=='1'?'2':'1'
        }
        updateStatusMovieArea(data).then(res=>{
          if(res.data.status=='ok'){
            this.$message.success('修改状态成功')
            this.getareaList()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
                
      });
      
    },
    // 区域列表
    getareaList(){
      getMovieAreaList(this.dataArea).then(res=>{
        if(res.data.status=='ok'){
          this.total = res.data.result.total
          this.tableData = res.data.result.data
        }
      })
    },
    orderBtns(){
      if(this.ordertime){
        this.dataorder.start_time = this.ordertime[0]
        this.dataorder.end_time = this.ordertime[1]
      }else{
        this.dataorder.start_time = ''
        this.dataorder.end_time = ''
      }
      this.dataorder.page = 1
      this.orderList()
    },
    orderChange(e){
      this.dataorder.page = e
      this.orderList()
    },
    orderList(){
      getMovieOrderList(this.dataorder).then(res=>{
        if(res.data.status=='ok'){
          this.total = res.data.result.total
          this.tableData = res.data.result.data
        }
      })
    },
    ListChange(e){
      this.typeData.page = e
      this.getListType()
    },
    // 分类列表
    getListType(){
      getMovieTypeList(this.typeData).then(res=>{
        if(res.data.status=='ok'){
          this.total = res.data.result.total
          this.tableData = res.data.result.data
        }
      })
    },
    // 添加分类
    addTypes(row){
      if(row){
        console.log(row)
        let data = {
          token:window.sessionStorage.getItem('Token'),
          id:row.id
        }
        getMovieTypeInfo(data).then(res=>{
          if(res.data.status=='ok'){
            this.formRe.type_name = res.data.result.type_name
            this.formRe.id = res.data.result.id
            this.Visible = true
          }
        })
      }else{
        this.formRe.type_name =  ''
        this.Visible = true
      }
    },
    dialogClose(){
      this.seeinfovisible = false
    },
    seeInfoFn(row){
      this.seeinfovisible = true;
      this.$nextTick(() => {
        this.$refs.seeinfoDialog.seeInfo(row);
      });
    },
    addlistPush(row){
      if(row){
        this.$router.push({
          name:'addlist',
          query:{
            id:row.id
          }
        })
      }else{
        this.$router.push({
          name:'addlist'
        })
      }
    },
    addseat(row){
      if(row){
        this.$router.push({
          name:'addcinema',
          query:{
            id:row.id
          }
        })
      }else{
        this.$router.push({
          name:'addcinema'
        })
      }
    },
    Close(){
      this.formRe.type_name = ''
      this.Visible = false
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
  }
}
</script>
<style lang="less" scoped>
.Tab_Css{
  display: flex;
  align-items: center;
  margin-top: 2rem;
  >div{
    width: 11.7rem;
    height: 4rem;
    border-radius: 0.4rem;
    background: #D9D9D9;
    color: #FFFFFF;
    font-size: 1.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 2rem;
    cursor: pointer;
  }
  .Tab_Active{
    background: #246DEB;
  }
}
.box{
  padding: 2rem;
  box-sizing: border-box;
  border-radius: 0.4rem;
  margin-top: 2rem;
  background: #fff;
  .box_top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .condition{
      display: flex;
      align-items: center;
      >span{
        color: #666666;
        font-size: 1.4rem;
      }
      ::v-deep .el-input{
        width: 22rem;
        &:nth-child(n+2){
          margin-left: 2rem;
        }
      }
      ::v-deep .el-select{
        width: 22rem;
        margin-left: 2rem;
      }
      .select_btns{
        width: 10rem;
        height: 4rem;
        margin-left: 2rem;
        border-radius: 0.4rem;
        background: #246DEB;
        color: #fff;
        font-size: 1.4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
    }
    .btns{
      display: flex;
      div{
        font-size:1.4rem;
        width: 9.8rem;
        height: 3.8rem;
        border-radius: 0.4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &:nth-child(1){
          border: 0.1rem solid #246DEB;
          color: #246DEB;
          margin-right: 2rem;
        }
        &:nth-child(2){
          border: 0.1rem solid #246DEB;
          color: #246DEB;
          margin-right: 2rem;
        }
        &:last-child{
          border: 0.1rem solid #E74C3C;
          color: #E74C3C;
        }
      }
    }
  }
  .table_box{
    margin-top: 2rem;
    .operation{
      display: flex;
      align-items: center;
    }
    .add_bianji{
      color: #246DEB;
      font-size: 1.4rem;
      margin-right: 2rem;
      cursor: pointer;
    }
    .detele{
      color: #E74C3C;
      font-size: 1.4rem;
      cursor: pointer;
    }
    
  }
}
 /deep/ .el-table th, /deep/.el-table td{
  text-align:left !important;
}
.itemBtnS{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 4rem;
      padding-bottom: 4rem;
      box-sizing: border-box;
      div{
        width: 10rem;
        height: 4rem;
        border-radius: 0.4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &:nth-child(1){
          color: #246DEB;
          border: 1px solid #246DEB;
          margin-right: 2rem;
        }
        &:nth-child(2){
          color: #fff;
          background: #246DEB;
        }
      }
    }
    .box_top_end{
      justify-content: flex-end !important;
    }
    .pagination {
      display: flex;
      justify-content: center;
      position: relative;
      align-items: center;
      height: 32px;
      margin: 42px auto;
      span {
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
      }
    }
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
  .totla{
    position: absolute;
    left: 2rem;
    width: 35rem;
    color: red !important;
  }
}

.orderContent{
  display: flex;
  flex-direction: column;
}

.orderContent span{
  text-align: left;
  color: #000000;
  font-size: 1.4rem;
  height: 2.6rem;

  &:nth-child(1){
    color: #468BC8;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.table_span_text{
  color: #246DEB !important;
  cursor: pointer;
}
.close_span{
  color: #E74C3C !important;
  cursor: pointer;
}
.order_boxs{
  ::v-deep .el-dialog__wrapper{
    margin: 20rem auto;
  }
}
</style>